<template>
  <div>
     <b-button
      v-permission="'newsletters.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>
    <Grid
      ref="grid"
      :service="service"
      route_name="newsletters"
      order_column="created_at"
      direction="desc">
      <template v-slot:filterZone >
        <div class="grid grid-cols-2 gap-2 pt-2">
          <div>
            <select-suggestion
              :key="groupNewsKey"
              column="name"
              model="GroupNews"
              v-model="selectedGroupNews"
              :label="$t('group_news.group')"
              :appendClearOption="true"
              placeholderText="Digite o nome do grupo"
              class="required"
              @clearSelection="clearSubgroupNews"
              @selected-model="clearSubgroupNews"
            />
          </div>
          <div>
            <select-suggestion
              :key="subgroupNewsKey"
              column="name"
              model="SubgroupNews"
              v-model="selectedSubgroupNews"
              :label="$t('subgroup_news.subgroup')"
              :appendClearOption="true"
              placeholderText="Digite o nome do subgrupo"
              class="required"
              :disabled="!enableSubgroupNews"
              :extraParamsFilters="{group_news_id: selectedGroupNews ? selectedGroupNews.id : null}"
            />
          </div>
        </div>
      </template>
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="title" sort-key="title">{{ $t('newsletter.title') }}</vs-th>
        <vs-th key="group_news_name" sort-key="group_news_name">{{ $t('group_news.group') }}</vs-th>
        <vs-th key="subgroup_news_name" sort-key="subgroup_news_name">{{ $t('subgroup_news.subgroup') }}</vs-th>
        <vs-th key="status" sort-key="status">{{ $t('newsletter.status') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="20%" key="title">
            <div> {{ tr.title }}</div>
          </vs-td>
          <vs-td width="20%" key="group_news_name">
            <div> {{ tr.group_news_name }}</div>
          </vs-td>
          <vs-td width="20%" key="subgroup_news_name">
            <div> {{ tr.subgroup_news_name }}</div>
          </vs-td>
          <vs-td width="15%" key="status">
            <div> {{ tr.status_fmt }}</div>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'newsletters.edit'"
                @click="props.edit(props.data[indextr].id)"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                v-tooltip.top="{content: 'Editar Informativo',delay: { show: 100, hide: 100 }}"/>
                <feather-icon
                  v-permission="'newsletters.clone'"
                  @click="confirmClone(props.data[indextr].id)"
                  icon="CopyIcon"
                  class="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
                  v-tooltip.top="{content: 'Clonar Informativo',delay: { show: 100, hide: 100 }}"/>
                <feather-icon
                  v-permission="'newsletters.detail'"
                  @click="detail(props.data[indextr].id)"
                  icon="EyeIcon"
                  class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                  v-tooltip.top="{content: 'Detalhar',delay: { show: 100, hide: 100 }}"/>
                <feather-icon
                  v-permission="'newsletters.delete'"
                  @click="props.destroy(props.data[indextr])"
                  icon="Trash2Icon"
                  class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                  v-tooltip.top="{content: 'Excluir',delay: { show: 100, hide: 100 }}"/>

                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                  <feather-icon
                    type="filled"
                    icon="MoreVerticalIcon"
                    class="h-5 w-5 mb-1 mr-1 stroke-current">
                  </feather-icon>
                  <vs-dropdown-menu>
                      <vs-dropdown-item>
                        <div
                          class="flex"
                          style="width: 150px;"
                          v-clipboard:copy="buildLink(props.data[indextr].link)"
                          v-clipboard:success="() => {notifySuccess($vs, 'Cópia realizada com sucesso.')}"
                          v-clipboard:error="() => {notifyError($vs, 'Não foi possível realizar a cópia.')}"
                          >
                          <div class="w-2/12">
                            <feather-icon
                                icon="LinkIcon"
                                svgClasses="h-5 w-5 mb-1 stroke-current text-primary"/>
                          </div>

                          <div class="w-10/12">
                            <div class="flex bg-gray-200 float-left">
                              {{ $t('action.copy_link') }}
                            </div>
                          </div>
                        </div>
                      </vs-dropdown-item>

                      <vs-dropdown-item v-if="enableCloneByGroup(props.data[indextr])">
                        <div
                          class="flex"
                          style="width: 150px;"
                          @click="confirmCloneByGroup(props.data[indextr])">
                          <div class="w-2/12">
                            <feather-icon
                                icon="GridIcon"
                                svgClasses="h-5 w-5 mb-1 stroke-current text-primary"/>
                          </div>

                          <div class="w-10/12">
                            <div class="flex bg-gray-200 float-left">
                              {{ $t('action.clone_by_group') }}
                            </div>
                          </div>
                        </div>
                      </vs-dropdown-item>
                      <vs-dropdown-item v-if="enableCloneBySubgroup(props.data[indextr])">
                        <div
                          class="flex"
                          style="width: 150px;"
                          @click="confirmCloneBySubgroup(props.data[indextr])">
                          <div class="w-2/12">
                            <feather-icon
                                icon="ListIcon"
                                svgClasses="h-5 w-5 mb-1 stroke-current text-primary"/>
                          </div>

                          <div class="w-10/12">
                            <div class="flex bg-gray-200 float-left">
                              {{ $t('action.clone_by_subgroup') }}
                            </div>
                          </div>
                        </div>
                      </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>

import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SelectSuggestion from '@/components/SelectSuggestion.vue'

import NewsletterService from '@/services/api/NewsletterService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    SelectSuggestion
  },
  data: () => ({
    selected: [],
    service: null,
    selectedGroupNews: null,
    selectedSubgroupNews: null,
    groupNewsKey: 0,
    subgroupNewsKey: 0,
  }),
  watch: {
    groupNewsFilter(val) {
      if (val) {
        this.$refs.grid.handleFilter(this.groupNewsFilter, 'group_news_id')
      } else {
        this.$refs.grid.resetFilters()
        this.$refs.grid.fetchGridData(true)
      }
    },
    subgroupNewsFilter(val) {
      if (val) {
        this.$refs.grid.handleFilter(this.subgroupNewsFilter, 'subgroup_news_id')
      } else {
        this.$refs.grid.resetFilters()
        this.$refs.grid.fetchGridData(true)
      }
    }
  },
  computed: {
    enableSubgroupNews(){
      return this.selectedGroupNews !== null && this.selectedGroupNews.id !== null
    },
    groupNewsFilter() {
      return this.isEmpty(this.selectedGroupNews) ? '' : this.selectedGroupNews.id
    },
    subgroupNewsFilter() {
      return this.isEmpty(this.selectedSubgroupNews) ? '' : this.selectedSubgroupNews.id
    }
  },
  methods: {
    addNew() {
      this.$router.push('/newsletters/create')
    },
    enableCloneByGroup(item){
      const groupId = _.get(item, 'subgroup.group.id')
      return groupId !== null && groupId !== undefined && groupId !== ''
    },
    enableCloneBySubgroup(item){
      const subgroupId = _.get(item, 'subgroup.id')
      return subgroupId !== null && subgroupId !== undefined && subgroupId !== ''
    },
    confirmClone(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja clonar este informativo?',
        accept: () => {
          this.clone(id)
        }
      })
    },
    clone(id) {
      this.$vs.loading()
      this.service.clone(id).then(
        response => {
          this.$router.push(`/newsletters/${response.id}/edit`)
          this.notifySuccess(
            this.$vs,
            'Informativo clonado com sucesso!',
            3000,
            'center-top'
          )
        }
      ).finally(() => this.$vs.loading.close())
    },
    detail(id) {
      this.$router.push({
        name: 'newsletter-detail',
        params: {
          id: id
        }
      })
    },
    buildLink(link){
      return `${this.protocolLocation()}/#/newsletters/pub/${link}`
    },
    reloadGrid(){
      this.$refs.grid.fetchGridData()
    },
    clearSubgroupNews() {
      this.selectedSubgroupNews = null
      this.subgroupNewsKey++
    },
    confirmCloneByGroup(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja clonar TODOS os informativos do grupo: ' + _.get(item, 'subgroup.group.name') + '?',
        accept: () => {
          this.cloneByGroup(item)
        }
      })
    },
    cloneByGroup(item) {
      const groupId = _.get(item, 'subgroup.group.id')
      if(!groupId){
        this.notifyWarning(this.$vs, 'Não é possível clonar por grupo, pois o informativo não possui um grupo/subgrupo selecionado.', 5000, 'center-top')
        return
      }

      this.$vs.loading()
      this.service.cloneByGroup(item.id).then(
        response => {
          this.notifySuccess(this.$vs, 'Informativo clonado com sucesso!', 3000, 'center-top')
          this.reloadGrid()
        })
        .catch(error => {
          this.notifyError(this.$vs, 'Erro ao clonar informativo.', 5000, 'center-top')
        })
        .finally(() => this.$vs.loading.close())
    },
    confirmCloneBySubgroup(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja clonar TODOS os informativos do subgrupo: ' + _.get(item, 'subgroup.name') + '?',
        accept: () => {
          this.cloneBySubgroup(item)
        }
      })
    },
    cloneBySubgroup(item) {
      const subgroupId = _.get(item, 'subgroup.id')
      if(!subgroupId){
        this.notifyWarning(this.$vs, 'Não é possível clonar por subgrupo, pois o informativo não possui um subgrupo selecionado.', 5000, 'center-top')
        return
      }

      this.$vs.loading()
      this.service.cloneBySubgroup(item.id).then(
        response => {
          this.notifySuccess(this.$vs, 'Informativo clonado com sucesso!', 3000, 'center-top')
          this.reloadGrid()
        })
        .catch(error => {
          this.notifyError(this.$vs, 'Erro ao clonar informativo.', 5000, 'center-top')
        })
        .finally(() => this.$vs.loading.close())
    }
  },
  beforeMount() {
    this.service = NewsletterService.build(this.$vs)
  }
}
</script>
